/*
 * ============================================================
 * Kinetic Carving Theme - Soft-launch gate URL hygiene
 * Copyright (c) 2026 Alpas Made. All rights reserved.
 * ============================================================
 *
 * Loaded by layout/theme.liquid when kc_soft_launch_gated is
 * true. The inline script in theme.liquid handles the actual
 * gate decision (cookie set, html.kc-bypass class) so the gate
 * never paints. This file is the deferred follow-up: it strips
 * the ?team=<TOKEN> param from the URL after the inline script
 * has consumed it, so the team token does not linger in the
 * address bar after auth.
 *
 * No-op if no team param is present.
 *
 * To remove: delete this file and remove the
 *   <script src="...kc-soft-launch.js" defer></script>
 * tag from layout/theme.liquid. The inline cookie+bypass logic
 * keeps working without this file (URL just stays untidy).
 */
(function () {
  'use strict';
  try {
    var qs = window.location.search;
    if (qs.indexOf('team=') === -1) return;
    var params = new URLSearchParams(qs);
    params.delete('team');
    var newQs = params.toString();
    var nextUrl = window.location.pathname + (newQs ? '?' + newQs : '') + window.location.hash;
    window.history.replaceState({}, document.title, nextUrl);
  } catch (e) {
    /* swallow */
  }
})();
